import { buildProps, definePropType } from '@ll-plus/utils'

import { TooltipProps } from 'ant-design-vue'
import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'
import type CustomSearcher from './custom-searcher.vue'

export interface customSearcherFieldItem {
  key: string // 字段名
  // dataType: string // 数据类型
  title: string // 查询别名
  type: string // 组件类型
  conditionType?: string // 运算符
  props: {
    [key: string]: any // 组件属性
  }
  [key: string]: any
}

// 定义组件props
export const customSearcherProps = buildProps({
  open: {
    type: Boolean,
    default: false,
  },
  fieldList: {
    type: definePropType<customSearcherFieldItem[]>(Array),
    default: () => [],
  },
  // 启用自定义运算符
  operatorSelectable: {
    type: Boolean,
    default: true,
  },
  // 最大查询数量
  maxSearchCount: {
    type: Number,
    default: 0,
  },
  // 开启徽标
  useBadge: {
    type: Boolean,
    default: true,
  },
  // 激活状态
  activeState: {
    type: Boolean,
    default: false,
  },
  // 气泡框位置
  placement: {
    type: definePropType<TooltipProps['placement']>(String),
  },
  // 查询图标
  searchIcon: {
    type: String,
  },
  // 新增查询文本
  addSearchText: {
    type: String,
  },
  // 保存方案文本
  saveSchemeText: {
    type: String,
  },
  // 开启用户自定义方案（本地存储）
  useLocalStorage: {
    type: Boolean,
    default: true,
  },
  size: {
    type: definePropType<SizeType | number>([String, Number]),
    default: 'large',
  },
  label: {
    type: String,
    default: '',
  },
  // 本地存储key
  localKey: {
    type: String,
    default: '34',
  },
} as const)

// props
export type CustomSearcherProps = ExtractPropTypes<typeof customSearcherProps>

// instance
export type CustomSearcherInstance = InstanceType<typeof CustomSearcher>
